import SettlementTypeEdit from './SettlementTypeEdit';
import SettlementTypesList from './SettlementTypesList';

const resource = {
  list: SettlementTypesList,
  edit: SettlementTypeEdit,
};

export default resource;
